/**
 * Created by emanuele on 04/02/2017.
 */
import React, {Component} from 'react'
import { Modal } from 'semantic-ui-react'
import PropTypes from 'prop-types';
import GareDocumentCreator from "./GareDocumentCreator";

class ModalGareDocumentCreator extends Component {
    constructor(props) {
        super(props);
        this.state = {isOpen:false};
        this.onClickOk = this.onClickOk.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
    }

    onClickOk(){
        this.setState({ isOpen: false })
        if (this.props.onClickOk !== undefined){
            this.props.onClickOk();
        }
    }
    onClickCancel(){
        this.setState({ isOpen: false })
    }

    handleOpen = () => {
        this.setState({ isOpen: true })
    }

    handleClose = () => {
        this.setState({ isOpen: false })
    }

    render(){
        return <Modal
            size={"mini"}
            trigger={this.props.children}
            open={this.state.isOpen}
            onClose={this.handleClose}
            onOpen={this.handleOpen}
            closeIcon
        >
            <Modal.Header>{this.props.title}</Modal.Header>
            <Modal.Content>
                <GareDocumentCreator gara={this.props.gara} onCloseClick={this.handleClose}/>
            </Modal.Content>
        </Modal>
    }

}
ModalGareDocumentCreator.PropTypes = {
    title: PropTypes.string,
    idDivisione: PropTypes.number.isRequired,
    gara: PropTypes.object.isRequired,
    onClickOk: PropTypes.func
}

ModalGareDocumentCreator.defaultProps = {
    title: "Attenzione",
};

export default ModalGareDocumentCreator


/** WEBPACK FOOTER **
 ** ./src/components/gare/ModalGareDocumentCreator.js
 **/